import Service from '../service';

export default class ConsigneeService extends Service {
  baseApi = '/user/consignees';

  async getConsignees(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async createConsignee(data) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, data);
  }

  async deleteConsignee(data) {
    const url = `${this.baseApi}`;
    return await this.deleteResource(url, data);
  }

  async archive(data) {
    const url = `${this.baseApi}/archive`;
    return await this.postResource(url, data);
  }
}
